/**
 * @generated SignedSource<<79cb14483af9f606b19d32406a75706d>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type ActionItemGroupsListMoveMutation$variables = {
  groupId: string;
  newOrder: number;
};
export type ActionItemGroupsListMoveMutation$data = {
  readonly moveCustomActionItemGroup: {
    readonly actionItemGroups: ReadonlyArray<{
      readonly id: string;
      readonly order: number;
    }> | null;
  } | null;
};
export type ActionItemGroupsListMoveMutation$rawResponse = {
  readonly moveCustomActionItemGroup: {
    readonly actionItemGroups: ReadonlyArray<{
      readonly id: string;
      readonly order: number;
    }> | null;
  } | null;
};
export type ActionItemGroupsListMoveMutation = {
  rawResponse: ActionItemGroupsListMoveMutation$rawResponse;
  response: ActionItemGroupsListMoveMutation$data;
  variables: ActionItemGroupsListMoveMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "groupId"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "newOrder"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "groupId",
        "variableName": "groupId"
      },
      {
        "kind": "Variable",
        "name": "newOrder",
        "variableName": "newOrder"
      }
    ],
    "concreteType": "MoveCustomActionItemGroup",
    "kind": "LinkedField",
    "name": "moveCustomActionItemGroup",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "ActionItemGroupNode",
        "kind": "LinkedField",
        "name": "actionItemGroups",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "order",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "ActionItemGroupsListMoveMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "ActionItemGroupsListMoveMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "f0138976df92daea98a7d2f75f75a016",
    "id": null,
    "metadata": {},
    "name": "ActionItemGroupsListMoveMutation",
    "operationKind": "mutation",
    "text": "mutation ActionItemGroupsListMoveMutation(\n  $groupId: ID!\n  $newOrder: Int!\n) {\n  moveCustomActionItemGroup(groupId: $groupId, newOrder: $newOrder) {\n    actionItemGroups {\n      id\n      order\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "0b1acc574ce78126f92a9da5847c04c9";

export default node;
